import React from 'react'
import PropTypes from 'prop-types'
import { getColor, sizes } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './SpinLoader.scss'

const SpinLoader = ({ color, size, ...domProps }) => (
  <div {...mergeProps()({ className: [styles.spinner, styles[size]], style: { color: getColor(color) } }, domProps)}>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
)

SpinLoader.defaultProps = {
  color: 'secondary',
}

SpinLoader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(sizes),
}

export default SpinLoader
